<template>
  <v-main fullscreen class="background">
    <v-container fill-height fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg5>
          <v-form @submit.prevent="login()" autocomplete="disabled">
            <v-card>
              <v-row class="pa-5">
                <!-- logo y nombre del sistema -->
                <v-col class="text-center" cols="12" sm="6">
                  <v-img
                    src="../assets/img/logo_1080.png"
                    aspect-ratio="2"
                    contain
                  ></v-img>
                  <h4 class="headline pt-5">{{vista.titulo}}</h4>
                  <h5 class="subtitle-1" >{{vista.subtitulo}}</h5>
                </v-col>

                <!-- parte del formulario -->
                <v-col cols="12" sm="6">
                  <h3
                    class="text-h5 font-weight-light mb-2 light-blue--text text--darken-2"
                  >
                    Iniciar sesión
                  </h3>
                  <v-text-field
                    name="login"
                    type="text"
                    v-model="credenciales.usuario"
                    label="Usuario"
                    prepend-inner-icon="mdi-account"
                    autocomplete="disabled"
                  ></v-text-field>

                  <v-text-field
                    name="password"
                    type="password"
                    v-model="credenciales.clave"
                    label="Clave"
                    prepend-inner-icon="mdi-lock"
                    autocomplete="disabled"
                  ></v-text-field>

                  <!-- mensajes de error -->
                  <v-alert v-if="error" dark type="error">{{ error }}</v-alert>

                  <!-- boton -->
                  <v-btn
                    type="submit"
                    color="light-blue lighten-2"
                    dark
                    block
                    :loading="cargando"
                    >{{ vista.botonIngresar }}</v-btn
                  >
                  <v-btn
                    class="mt-3"
                    type="button"
                    color="green lighten-2"
                    dark
                    block
                    @click="goToCliente()"
                    >{{ vista.botonCliente }}</v-btn
                  >

                </v-col>
              </v-row>
            </v-card>
            <v-row>
              <v-col class="text-center ">
                <h5>
                  <a
                    class="text-subtitle-1 font-weight-light text-decoration-none white--text"
                    href="https://blito.ar/"
                    >Volver a blito.ar</a
                  >
                </h5>
              </v-col>
            </v-row>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import MenuService from "../services/Menu.service";

export default {
  data() {
    return {
      credenciales: {
        usuario: "",
        clave: "",
      },
      vista: {
        titulo: "Gestión de Negocios!",
        subtitulo: "",
        botonIngresar: "Ingresar",
        botonCliente: "Soy Cliente",
      },
      error: "",
      cargando: false,
    };
  },
  methods: {
    login() {
      // limpiar error
      this.error = "";

      // le dice que esta cargando...
      this.cargando = true;

      // realiza el login
      this.$auth
        .login({
          username: this.credenciales.usuario,
          password: this.credenciales.clave,
        })
        .then((res) => {})
        .catch((err) => {
          this.cargando = false;
          if (err) {
            if (err.data) {
              this.error = err.data.message;
            }
          }
        });
    },
    goToCliente: function () {
        location.href='https://nol.blito.net.ar/Login/LoginCliente'
    }
  },
};
</script>

<style scoped>
.background {
  height: 100%;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  -webkit-animation: Gradient 15s ease infinite;
  -moz-animation: Gradient 15s ease infinite;
  animation: Gradient 15s ease infinite;
}
@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
